import { P2GButtonGroup, P2GButtonGroupItem, P2GTab, P2GTabs } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';

export type SubNavItemType = { translationKey: string; label: string; tab: string };

export const GetDefaultSubItem = (options: SubNavItemType[], startTab?: string) => {
  const tab = startTab || window.location.hash?.replace('#', '');
  const tabs = options.map((x) => x.tab);
  return tab && tabs.includes(tab) ? tab : tabs[0];
};

export const SubNavButtonGroup = ({
  options,
  selectedOption,
  setSelectedOption,
  translationNameSpace
}: {
  options: SubNavItemType[];
  selectedOption: string;
  setSelectedOption: (value: string) => void;
  translationNameSpace: string;
}) => {
  const { t } = useTranslation(translationNameSpace);

  if (options.length <= 1) {
    return null;
  }

  return (
    <P2GButtonGroup>
      {options.map((option) => (
        <P2GButtonGroupItem value={option.tab} onClick={setSelectedOption} key={option.tab} selected={selectedOption}>
          {t(option.translationKey, { defaultValue: option.label })}
        </P2GButtonGroupItem>
      ))}
    </P2GButtonGroup>
  );
};

export const SubNavTabs = ({
  options,
  selectedOption,
  setSelectedOption,
  translationNameSpace
}: {
  options: SubNavItemType[];
  selectedOption: string;
  setSelectedOption: (value: string) => void;
  translationNameSpace: string;
}) => {
  const { t } = useTranslation(translationNameSpace);

  if (options.length <= 1) {
    return null;
  }

  return (
    <P2GTabs value={options.findIndex((x) => x.tab === selectedOption)}>
      {options.map((option, i) => (
        <P2GTab
          onClick={() => setSelectedOption(option.tab)}
          key={option.tab}
          index={i}
          label={t(option.translationKey, { defaultValue: option.label })}
        />
      ))}
    </P2GTabs>
  );
};
